<ps-ui-tab-group
  (activeIndexChange)="setActiveTab($event)"
  [activeIndex]="activeTabIndex"
  *ngIf="tabs.length > 1"
>
  <ps-ui-tab *ngFor="let tab of tabs" [label]="tab.title"></ps-ui-tab>
</ps-ui-tab-group>
<div
  class="container p-0"
  [ngClass]="{ 'p-0': tabs.length === 1, 'pt-4': tabs.length > 1 }"
>
  <div class="row">
    <div class="col">
      <p *ngIf="!tabs.length || activeTab?.title === tabs[1]?.title">
        To reconcile completes, use the template to upload transaction IDs of
        every complete delivered for this project. Any IDs that we have recorded
        as status complete that you do not upload an ID for within the eligible
        timeframe will be overriden with a termination status.
      </p>
    </div>
  </div>
  <div class="row upload-section-tabs">
    <div
      class="col"
      *ngIf="
        !tabs.length || activeTab?.title === tabs[1]?.title;
        else liveOptions
      "
    >
      <label>Complete(s) Achieved in Previous Month:</label> <br /><br />
      <label
        >{{ availReconcileSurvey.preMonthCount }} Available for Reconcilation
        Until {{ prevMonth }}.</label
      ><br /><br /><br />
      <label>Complete(s) Achieved in Current Month:</label><br /><br />
      <label
        >{{ availReconcileSurvey.curMonthCount }} Available For Reconcilation
        Until {{ currentMonth }}.</label
      ><br /><br /><br />
      <label
        >{{ availReconcileSurvey.curMonthNotElgbCount }} Complete(s) Not Yet
        Eligible For Reconciliation.</label
      >
    </div>
    <ng-template #liveOptions>
      <div class="col pt-4">
        <div class="d-flex">
          <p class="h4">Choose the type of reconciliation</p>
        </div>
        <p class="mb-4">
          <small>How do you want to mark the transaction uploaded?</small>
        </p>
        <div class="radio-button-upload">
          <label>
            <input
              type="radio"
              class="form-check-input"
              name="staus"
              [(ngModel)]="desiredStatus"
              [value]="LIVE_RECO_STATUS_RADIO_BUTTONS.REJECT"
              (ngModelChange)="setOperationType()"
            />
            Rejects
          </label>
          <label [class.accept-button-disable]="disableAcceptRadioButton">
            <input
              type="radio"
              class="form-check-input"
              name="staus"
              [(ngModel)]="desiredStatus"
              [value]="LIVE_RECO_STATUS_RADIO_BUTTONS.ACCEPT"
              [disabled]="disableAcceptRadioButton"
              (ngModelChange)="setOperationType()"
            />
            Accept
          </label>
          <div class="rule">
            <span class="help-tip">
              <i class="fa fa-info-circle" aria-hidden="true"></i>
              <strong>Rules</strong>
              <p>
                <span>
                  Rejects
                  <ol>
                    <li>
                      Use this tool when project status is: live, paused, or
                      closed.
                    </li>
                    <li>
                      To use this tool, you will provide a list of transactions
                      that you want to change the status from ‘COMPLETE’ to
                      ‘REJECT’.
                    </li>
                  </ol>
                  Accept
                  <ol>
                    <li>Use this tool once the project status is: closed</li>
                    <li>
                      To use this tool, you will provide a list of COMPLETES
                      that you want to ACCEPT. All other ‘completes’ will be
                      rejected.
                    </li>
                  </ol>
                  Each respondent transaction is eligible for a single
                  reconciliation. If a transaction was altered before closing,
                  using the REJECT method, it is no longer eligible for
                  reconciliation.
                </span>
              </p>
            </span>
          </div>
        </div>
      </div>
    </ng-template>
    <div class="col">
      <ps-ui-adjustment-file-upload
        [userId]="userId"
        [userName]="usrName"
        [adjustmentReconciliatonRecord]="selectedReconcileFilesArray"
        [operationType]="operationType"
        [showBackToDashboardButton]="false"
        [showDownloadTemplateText]="true"
        [desiredStatus]="desiredStatus"
      ></ps-ui-adjustment-file-upload>
    </div>
  </div>
  <div class="row">
    <div class="col">
      <ps-ui-adjustment-table
        [adjustmentReconciliatonRecord]="selectedReconcileFilesArray"
        [operationType]="operationType"
        [userId]="userId"
        [userName]="usrName"
        [showDownloadTemplateText]="true"
      >
      </ps-ui-adjustment-table>
    </div>
  </div>
</div>
